import { FC, Fragment } from "react";

import { TimelineEvent, TimelineEventDetails } from "src/components/Timeline/TimelineEvent.tsx";

type TimelineProps = {
  events: TimelineEventDetails[];
};

const Timeline: FC<TimelineProps> = ({ events }) => {
  return (
    <Fragment>
      {events.map((event, index) => (
        <TimelineEvent key={index} {...event} isLast={index === events.length - 1} />
      ))}
    </Fragment>
  );
};
export default Timeline;
